import { render } from "./StandardDropdown.vue?vue&type=template&id=a4caf7e2&scoped=true"
import script from "./StandardDropdown.vue?vue&type=script&lang=js"
export * from "./StandardDropdown.vue?vue&type=script&lang=js"

import "./StandardDropdown.vue?vue&type=style&index=0&id=a4caf7e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4caf7e2"]])

export default __exports__